import GoldenProgressBar from "./GoldenProgressBar";
import LabelingForm from "./LabelingForm";
import { useGoldenLabeling } from "./useGoldenLabeling";

/** Progress toward the golden set plus the one-at-a-time labeling workflow. */
const LabelingPanel = () => {
  const { goldenCase, progress, writable, loading, saving, error, save, skip } =
    useGoldenLabeling();

  return (
    <div className="space-y-4">
      {progress ? <GoldenProgressBar labeled={progress.labeled} target={progress.target} /> : null}
      {error ? (
        <p role="alert" className="text-sm text-destructive">
          {error}
        </p>
      ) : null}
      {loading ? (
        <p className="text-sm text-muted-foreground">Loading…</p>
      ) : goldenCase ? (
        <LabelingForm
          key={goldenCase.id}
          goldenCase={goldenCase}
          writable={writable}
          saving={saving}
          onSave={save}
          onSkip={skip}
        />
      ) : (
        !error && (
          <p className="rounded-md border p-4 text-sm">
            All done: there are no saved chats left to label.
          </p>
        )
      )}
    </div>
  );
};

export default LabelingPanel;
